import { render, staticRenderFns } from "./VideoCourseItem.vue?vue&type=template&id=4ca82c8c&scoped=true&"
import script from "./VideoCourseItem.vue?vue&type=script&lang=js&"
export * from "./VideoCourseItem.vue?vue&type=script&lang=js&"
import style0 from "./VideoCourseItem.vue?vue&type=style&index=0&id=4ca82c8c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca82c8c",
  null
  
)

export default component.exports